<template>
    <div>
        <MainSection
            @isImpactSection="updateImpactSection" />
        <ProductContentBG 
            @setCurrentActiveProductTab="updateProductActive"
            :productAct="productActive"/>
        <ImpactSection 
            v-if="(impactSectionFlag == 'impactSectionActive')"
            :dataCurrentActiveProductTab="currentActiveProductTab"
            @isAwardSection="updateAwardSection"
            />
        <AwardSection 
            v-if="awardSectionFlag == 'awardSectionActive'"
            @isPublishedSection="updatePublishedSection" />
        <PublishedSection 
            v-if="publishedSectionFlag == 'publishedSectionActive'"
            @isPartnerSection="updatePartnerSection" />
        <PartnerSection
            v-if="partnerSectionFlag == 'partnerSectionActive'"
            @isServiceSection="updateServiceSection"/>
        <ServiceSection
            v-if="serviceSectionFlag == 'serviceSectionActive'"
            @isSitemapSection="updateSitemapSection"/>
        <SitemapSection
            v-if="sitemapSectionFlag == 'sitemapSectionActive'"/>
    </div>            
</template>

<script>


import MainSection from './components/MainSection';
import ProductContentBG from './components/ProductContentBG';
import ImpactSection from './components/ImpactSection';
import AwardSection from './components/AwardSection';
import PublishedSection from './components/PublishedSection';
import PartnerSection from './components/PartnerSection';
import ServiceSection from './components/ServiceSection';
import SitemapSection from './components/SitemapSection';

import SkeletonLoading from './components/utils/SkeletonLoading';

export default {
    metaInfo: {
        
        meta: [            
                // OpenGraph data (Most widely used)
                {property: 'og:title', content: 'Learn Quran - High Quality Quran Apps'},
                {property: 'og:site_name', content: 'Learn Quran'},
                // The list of types is available here: http://ogp.me/#types
                {property: 'og:type', content: 'website'},
                // Should the the same as your canonical link, see below.
                // {property: 'og:url', content: 'https://www.my-site.com/my-special-page'},
                // {property: 'og:image', content: 'https://www.my-site.com/my-special-image.jpg'},
                // Often the same as your meta description, but not always.
                {property: 'og:description', content: "High quality apps for engaging with the Al-Qur'an — from learning to reciting the Quran. Our mission is to create the best tech solutions to help everyone connect with the Quran more easily, deeply, and effectively through technology."},

                // Twitter card
                {name: 'twitter:card', content: 'summary'},
                {name: 'twitter:site', content: 'https://www.my-site.com/my-special-page'},
                {name: 'twitter:title', content: 'My Page Title ← My Site'},
                {name: 'twitter:description', content: 'I have things here on my site.'},
                // Your twitter handle, if you have one.
                {name: 'twitter:creator', content: '@alligatorio'},
                {name: 'twitter:image:src', content: 'https://www.my-site.com/my-special-image.jpg'},

                // Google / Schema.org markup:
                {itemprop: 'name', content: 'Learn Quran - High Quality Quran Apps'},
                {itemprop: 'description', content: "High quality apps for engaging with the Al-Qur'an — from learning to reciting the Quran. Our mission is to create the best tech solutions to help everyone connect with the Quran more easily, deeply, and effectively through technology."},
                {itemprop: 'image', content: 'https://learn-quran.co/assets/logos/logo_lq_white_min_v2024.png'}
            ]
        },
    name: 'App',
    components: {        
        MainSection,        
        ProductContentBG,
        ImpactSection,
        AwardSection,
        PublishedSection,
        PartnerSection,
        ServiceSection,
        SitemapSection,        
    },
    data() {
        return {
            productActive: '',
            impactSectionFlag: '',
            publishedSectionFlag: '',
            partnerSectionFlag: '',
            sitemapSectionFlag: '',
            awardSectionFlag: '',
            serviceSectionFlag: '',
            currentActiveProductTab: ''
        }
    }, 
    mounted() {
        this.track()
    },
    methods: {        
        updateProductActive(item) {
            this.productActive = item;
            this.currentActiveProductTab = item;
        },
        updateImpactSection(item) {
            this.impactSectionFlag = item;
        },
        updateAwardSection(item) {
            this.awardSectionFlag = item;
        },
        updatePublishedSection(item) {
            this.publishedSectionFlag = item;
        },
        updatePartnerSection(item) {
            this.partnerSectionFlag = item;
        },
        updateServiceSection(item) {
            this.serviceSectionFlag = item;
        },
        updateSitemapSection(item) {
            this.sitemapSectionFlag = item;
        },
        track() {
            this.$gtag.pageview(this.$route.path)
        }
    }
}
</script>

<style>
/* @import 'assets/vendor/fontawesome-free/css/all.min.css'; */
/* @import 'assets/vendor/magnific-popup/magnific-popup.css'; */
@import 'assets/css/creative.css';
.mt-5 {
    margin-top: -1.5rem!important;
}
</style>
